export default __webpack_public_path__ + "static/media/sony-color.7b39fa8f.svg";